const LOG = `mutation Log($input: [LogInput]) {
    log(input: $input)
  }
`;

export default LOG;
